import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "first-para grey-letters" }
const _hoisted_4 = {
  key: 0,
  class: "grey-letters"
}
const _hoisted_5 = {
  key: 1,
  class: "grey-letters"
}
const _hoisted_6 = {
  key: 1,
  class: "button-container"
}
const _hoisted_7 = {
  key: 0,
  class: "unsubscribe-window"
}
const _hoisted_8 = {
  key: 2,
  class: "button-container"
}

import { ref, onMounted } from 'vue';
import { polarClient } from '@/lib/polar';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import PolarSub from '@/components/PolarSub.vue';
import User from '@/types/User';
import { useUserStore } from '@/stores/user';



export default /*@__PURE__*/_defineComponent({
  __name: 'SubPanel',
  props: {
    user: {}
  },
  setup(__props: any) {

const props = __props;


const username = ref<string>('');
const unSubWindowVisible = ref<boolean>(false);

const authStore = useAuthStore();
const { session } = storeToRefs(authStore);
const apiUrl = process.env.VUE_APP_DJANGO_BACKEND;

const toggleUnsubscribeWindow = () => {
  unSubWindowVisible.value = !unSubWindowVisible.value;
};

const handleManageSubscription = async () => {
  try {
      const result = await polarClient.customerSessions.create({
        customerId: props.user.polar_customer_id
      });
      
      window.location.href = result.customerPortalUrl;
  } catch (error) {
      console.error('Error managing subscription:', error);
  }
};


onMounted(async () => {
  if (session.value) {
      username.value = session.value.user.email || "";
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("h1", null, "Subscription", -1)),
    (_unref(session))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, "Name: " + _toDisplayString(_ctx.user.username), 1),
          (_ctx.user.is_subscribed)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Has subscribed: Yes"))
            : (_openBlock(), _createElementBlock("p", _hoisted_5, "Has subscribed: No")),
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "grey-letters" }, "price: 5.99 $", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "grey-letters" }, "billing period: monthly", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "grey-letters" }, "last payment date: 2025-02-12", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "grey-letters" }, "next billing date: 2025-03-12", -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.user.is_subscribed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "manage-btn",
            onClick: handleManageSubscription
          }, "Manage Subscription"),
          (unSubWindowVisible.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createStaticVNode("<p data-v-28b36410>At the moment, unsubscribing works via your email: </p><ul data-v-28b36410><li data-v-28b36410>Go to your <strong data-v-28b36410>inbox.</strong></li><li data-v-28b36410>Find the <strong data-v-28b36410>email</strong> that confirmed your subscription, by our payment <strong data-v-28b36410>provider Polar.sh</strong></li><li data-v-28b36410>Open it and just click, <strong data-v-28b36410>Unsubscribe.</strong></li><li data-v-28b36410>If you can&#39;t find the email just <strong data-v-28b36410>contact us</strong>, and we will handle it for you.</li><li data-v-28b36410>Thank you!</li></ul>", 2)),
                _createElementVNode("div", { class: "button-container" }, [
                  _createElementVNode("button", {
                    class: "close-btn",
                    onClick: toggleUnsubscribeWindow
                  }, "Close")
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(PolarSub, { user: _ctx.user }, null, 8, ["user"])
        ]))
  ]))
}
}

})